const common = {
  "nav.home": "Start",
  "nav.services": "Leistungen",
  "nav.about": "Über uns",
  "nav.pricing": "Preise",
  "nav.testimonials": "Bewertungen",
  "nav.contact": "Kontakt",
  "nav.booking": "Termin",
  "nav.gallery": "Galerie",
  "nav.team": "Team",

  "hero.title_line1": "Ihre Schönheit.",
  "hero.title_line2": "Unsere Kunst.",
  "hero.subtitle": "Premium Zahnmedizin, plastische Chirurgie & Haartransplantation in luxuriöser Atmosphäre. International ausgezeichnete Experten – bis zu 70% günstiger als in DE/AT/CH.",
  "hero.cta": "Jetzt Termin vereinbaren",
  "hero.badge": "PREMIUM KLINIK TIRANA · ZAHNMEDIZIN, CHIRURGIE & HAARTRANSPLANTATION",
  "hero.stat1.value": "7.500+",
  "hero.stat1.label": "Patienten",
  "hero.stat2.value": "15",
  "hero.stat2.label": "Jahre Erfahrung",
  "hero.stat3.value": "98%",
  "hero.stat3.label": "Zufriedenheit",

  "services.tag": "UNSERE LEISTUNGEN",
  "services.heading": "Exzellenz in jeder Behandlung",
  "services.dental.title": "Zahnmedizin",
  "services.dental.desc": "Zahnimplantate, Veneers, Zirkonkronen, Bleaching und mehr. Premium-Zahnersatz mit modernster 3D-Diagnostik – bis 70% günstiger als in Deutschland.",
  "services.dental.count": "12 Behandlungen",
  "services.surgery.title": "Plastische Chirurgie",
  "services.surgery.desc": "Facelifting, Nasenkorrektur, Brustvergrößerung, Liposuktion und mehr. Höchste Sicherheitsstandards mit Hotel & Transfer inklusive.",
  "services.surgery.count": "21 Eingriffe",
  "services.hair.title": "Haartransplantation",
  "services.hair.desc": "FUE-Haartransplantation mit modernster Mikropunktur-Technik. Bis 5.000 Grafts – absolut narbenfrei, natürlich dichtes Ergebnis. Inkl. kostenloser Haaranalyse.",
  "services.hair.count": "1 Behandlung",
  "services.cta": "Alle Leistungen entdecken",

  "about.tag": "UNSERE HEIMAT",
  "about.heading_line1": "Schönheit, geboren",
  "about.heading_line2": "in Albanien.",
  "about.description": "Im Herzen von Tirana, der pulsierenden Hauptstadt Albaniens, entstand Esteva Clinic aus einer Vision: Weltklasse-Ästhetik mit der Wärme mediterraner Gastfreundschaft zu vereinen. Albanien — ein Land von atemberaubender Schönheit, vom türkisblauen Wasser der Adria bis zu den majestätischen Gipfeln der Albanischen Alpen — erlebt gerade eine spektakuläre Renaissance. Während das Land rasant wächst und sich zu einem der gefragtesten Reiseziele Europas entwickelt, haben wir in Tirana einen Ort geschaffen, an dem internationale Spitzenmedizin auf das authentische Gefühl trifft, wirklich willkommen zu sein. Unsere Klinik spiegelt den Geist Albaniens wider: jung, ambitioniert, voller Herzblut — und bereit, die Welt zu erobern.",
  "about.quote": "Albanien hat mich gelehrt, dass wahre Schönheit aus Authentizität entsteht. Hier, zwischen Bergen und Meer, wachsen wir gemeinsam — das Land, unser Team und jeder einzelne Mensch, der zu uns kommt.",
  "about.name": "Dr. Nertila Basha",
  "about.position": "CEO, Zahnärztin, Implantologin & Prothetikerin",

  "pricing.tag": "PREISPAKETE",
  "pricing.heading_line1": "Transparente",
  "pricing.heading_line2": "Exzellenz.",
  "pricing.subtitle": "Jedes Paket individuell auf Ihre Bedürfnisse abgestimmt. Ohne versteckte Kosten, ohne Kompromisse.",
  "pricing.basic.title": "Essential",
  "pricing.basic.price": "ab 1.490 €",
  "pricing.basic.feature1": "Erstberatung & Analyse",
  "pricing.basic.feature2": "1 Behandlung nach Wahl",
  "pricing.basic.feature3": "Nachsorge-Paket Basic",
  "pricing.premium.title": "Premium",
  "pricing.premium.price": "ab 3.990 €",
  "pricing.premium.feature1": "VIP-Erstberatung",
  "pricing.premium.feature2": "2 Behandlungen kombiniert",
  "pricing.premium.feature3": "Premium Nachsorge & Pflegeprodukte",
  "pricing.luxe.title": "Luxe",
  "pricing.luxe.price": "ab 7.490 €",
  "pricing.luxe.feature1": "Persönlicher Beauty Concierge",
  "pricing.luxe.feature2": "3 Behandlungen + Hotelpaket",
  "pricing.luxe.feature3": "1 Jahr Nachsorge & Garantie",
  "pricing.exclusive.title": "Exclusif",
  "pricing.exclusive.price": "Individuell",
  "pricing.exclusive.feature1": "Rundum-Transformation",
  "pricing.exclusive.feature2": "Alle Behandlungen inklusive",
  "pricing.exclusive.feature3": "Lebenslange Nachsorge",
  "pricing.dental_title": "DENTAL PREISLISTE",
  "pricing.surgery_title": "PLASTISCHE CHIRURGIE PREISLISTE",
  "pricing.hair_title": "HAARTRANSPLANTATION PREISLISTE",
  "pricing.included_title": "Inklusive Leistungen",
  "pricing.included_over_3000": "Bei Kostenvoranschlägen über 3.000 €: Hotel, Taxi, Flugticket und 3D-Mundscan sind inklusive.",
  "pricing.included_over_1500": "Bei Kostenvoranschlägen über 1.500 €: Hotel, Taxi und 3D-Mundscan sind inklusive.",
  "pricing.table_service": "LEISTUNG",
  "pricing.table_price": "PREIS (EUR)",
  "pricing.table_stay": "KH & HOTELAUFENTHALT",
  "pricing.table_total": "GESAMT",
  "pricing.note_individual": "Individuelle Preise können je nach Komplexität des Eingriffs variieren. Ein detaillierter Kostenvoranschlag wird bei Ihrer Konsultation erstellt.",
  "pricing.cta": "Kostenlose Beratung",
  "instagram.tag": "FOLGE UNS",
  "instagram.heading": "Einblicke in die Exzellenz.",
  "instagram.subtitle": "Begleite uns auf Instagram für exklusive Einblicke, Vorher-Nachher-Momente und die neuesten Trends aus der ästhetischen Medizin.",
  "instagram.cta": "@estevaclinic folgen",

  "testimonials.tag": "KUNDENSTIMMEN",
  "testimonials.heading": "Was unsere Kunden sagen",

  "booking.tag": "TERMINBUCHUNG",
  "booking.heading_line1": "Ihre Reise beginnt",
  "booking.heading_line2": "mit einem Gespräch.",
  "booking.description": "Vereinbaren Sie jetzt Ihr persönliches Beratungsgespräch. Unsere Experten nehmen sich Zeit für Ihre individuellen Wünsche und erstellen ein maßgeschneidertes Behandlungskonzept – diskret und vertraulich.",
  "booking.cta": "Termin vereinbaren",
  "booking.hero_subtitle": "Wählen Sie Ihr Wunschdatum und Ihre bevorzugte Uhrzeit. Unser Team wird sich innerhalb von 24 Stunden mit einer Bestätigung bei Ihnen melden.",
  "booking.select_date_hint": "Bitte wählen Sie zuerst ein Datum aus, um verfügbare Uhrzeiten anzuzeigen.",
  "booking.your_data": "Ihre Daten",
  "booking.form_subtitle": "Füllen Sie das Formular aus, um Ihren Termin zu finalisieren.",
  "booking.firstname": "Vorname *",
  "booking.firstname_placeholder": "Vorname",
  "booking.lastname": "Nachname *",
  "booking.lastname_placeholder": "Nachname",
  "booking.email": "E-Mail *",
  "booking.email_placeholder": "ihre@email.de",
  "booking.phone": "Telefon *",
  "booking.phone_placeholder": "+49 123 4567890",
  "booking.service_label": "Gewünschte Behandlung *",
  "booking.service_placeholder": "Bitte wählen",
  "booking.service_combined": "Kombinierte Behandlung",
  "booking.service_consultation": "Beratungsgespräch",
  "booking.package_label": "Gewünschtes Paket",
  "booking.package_undecided": "Noch unentschlossen",
  "booking.package_essential": "Essential – ab 1.490 €",
  "booking.package_premium": "Premium – ab 3.990 €",
  "booking.package_luxe": "Luxe – ab 7.490 €",
  "booking.package_exclusif": "Exclusif – Individuell",
  "booking.message_label": "Besondere Wünsche oder Anmerkungen",
  "booking.message_placeholder": "Teilen Sie uns mit, worauf wir besonders achten sollen...",
  "booking.max_chars": "Max. 500 Zeichen",
  "booking.privacy_consent": "Ich stimme zu, dass meine Daten zur Terminvereinbarung gespeichert und verarbeitet werden. Ich habe die Datenschutzerklärung zur Kenntnis genommen.",
  "booking.select_datetime_warning": "Bitte wählen Sie Datum und Uhrzeit aus, um die Buchung abzuschließen.",
  "booking.success_title": "Vielen Dank für Ihre Buchung!",
  "booking.success_message": "Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
  "booking.time_label": "Uhrzeit wählen",
  "booking.time_selected": "Ausgewählt:",
  "booking.time_unit": "Uhr",

  "footer.tagline": "Esteva Clinic – Wo Schönheit Kunst wird.",
  "footer.services": "Leistungen",
  "footer.about": "Über uns",
  "footer.legal": "Rechtliches",
  "footer.contact": "Kontakt",
  "footer.hair": "Zahnmedizin",
  "footer.dental": "Zahnmedizin",
  "footer.surgery": "Plastische Chirurgie",
  "footer.botox": "Plastische Chirurgie",
  "footer.team": "Unser Team",
  "footer.philosophy": "Philosophie",
  "footer.career": "Karriere",
  "footer.press": "Presse",
  "footer.imprint": "Impressum",
  "footer.privacy": "Datenschutz",
  "footer.terms": "AGB",
  "footer.faq": "FAQ",
  "footer.newsletter_title": "Bleiben Sie inspiriert.",
  "footer.newsletter_subtitle": "Exklusive Einblicke, neue Behandlungen und besondere Angebote direkt in Ihr Postfach.",
  "footer.newsletter_placeholder": "Ihre E-Mail-Adresse",
  "footer.newsletter_button": "Abonnieren",
  "footer.newsletter_loading": "Wird gesendet...",
  "footer.newsletter_success": "Vielen Dank! Sie erhalten in Kürze eine Bestätigungs-E-Mail.",
  "footer.copyright": "© 2026 Esteva Clinic. Alle Rechte vorbehalten.",
  "footer.seo_text": "Esteva Clinic ist Ihre Premium-Schönheitsklinik und Zahnklinik in Tirana, Albanien. Wir bieten Zahnimplantate, Zirkonkronen, Veneers, Haartransplantation (FUE), Brustvergrösserung, Nasenkorrektur, Facelifting, Botox, Liposuktion und plastische Chirurgie bis zu 70% günstiger als in der Schweiz, Deutschland und Österreich. Patienten aus Zürich, Basel, Bern, Wien, München und Berlin vertrauen auf Esteva Clinic. Kostenlose Erstberatung — jetzt Termin vereinbaren.",

  "language.de": "DE",
  "language.it": "IT",
  "language.fr": "FR",
  "language.en": "EN",
  "language.sq": "SQ",

  "gallery.tag": "VORHER &amp; NACHHER",
  "gallery.heading_line1": "Ergebnisse, die",
  "gallery.heading_line2": "für sich sprechen.",
  "gallery.subtitle": "Echte Transformationen unserer Kunden. Jedes Bild erzählt eine Geschichte von neuer Selbstsicherheit und natürlicher Schönheit.",
  "gallery.filter_all": "Alle",
  "gallery.filter_hair": "Zahnmedizin",
  "gallery.filter_dental": "Zahnmedizin",
  "gallery.filter_surgery": "Plastische Chirurgie",
  "gallery.before": "Vorher",
  "gallery.after": "Nachher",
  "gallery.view_details": "Details ansehen",
  "gallery.close": "Schließen",
  "gallery.no_results": "Keine Ergebnisse in dieser Kategorie gefunden.",
  "gallery.results_count": "{{count}} Ergebnisse",
  "gallery.patient": "Patient",
  "gallery.treatment": "Behandlung",
  "gallery.result_after": "Ergebnis nach",
  "gallery.months": "Monaten",
  "gallery.disclaimer": "Die gezeigten Ergebnisse sind exemplarisch. Individuelle Ergebnisse können variieren.",

  "service_detail.how_it_works": "DER ABLAUF",
  "service_detail.benefits": "IHRE VORTEILE",
  "service_detail.faq": "HÄUFIGE FRAGEN",
  "service_detail.process_title": "Der Ablauf",
  "service_detail.benefits_title": "Ihre Vorteile",
  "service_detail.faq_title": "Häufige Fragen",
  "service_detail.cta_heading": "Bereit für Ihre Transformation?",
  "service_detail.cta_subtitle": "Vereinbaren Sie jetzt Ihr persönliches, unverbindliches Beratungsgespräch. Wir nehmen uns Zeit für Sie.",
  "pricing.back_to_pricing": "Zurück zur Preisliste",
  "pricing.view_details": "Details",

  "team.tag": "UNSER TEAM",
  "team.heading_line1": "Exzellenz braucht",
  "team.heading_line2": "Gesichter.",
  "team.subtitle": "Lernen Sie die Experten kennen, die Esteva Clinic zur ersten Adresse für ästhetische Premium-Behandlungen in Europa machen. Jedes Teammitglied ist ein Meister seines Fachs.",
  "team.show_more": "Mehr erfahren",
  "team.show_less": "Weniger anzeigen",
  "team.cta_heading": "Bereit für Ihre Transformation?",
  "team.cta_subtitle": "Unser Team freut sich darauf, Sie kennenzulernen und Ihren persönlichen Weg zu neuer Schönheit zu begleiten.",
  "team.cta_button": "Jetzt Beratungsgespräch vereinbaren",
  "clinic.tag": "UNSERE PRAXIS",
  "clinic.heading_line1": "Räume, die auf",
  "clinic.heading_line2": "Ihr Wohlbefinden zugeschnitten sind.",
  "clinic.subtitle": "Moderne Klinik und hochmoderne Ausstattung in Tirana. Vom Lounge-Komfort bis zur Hygiene des Dentallabors — jedes Detail für Ihr Wohlbefinden.",
  "clinic.label_dental": "Dentallabor",
  "clinic.label_consultation": "Beratungszimmer",
  "clinic.label_waiting": "Wartebereich",
  "clinic.label_reception": "Empfangsbereich",
  "clinic.dental_lab": "Modernes Dentallabor mit hochmoderner Ausstattung",
  "clinic.consultation": "Gemütliches Beratungszimmer für persönliche Gespräche",
  "clinic.waiting": "Geräumiger und einladender Wartebereich",
  "clinic.reception": "Moderner Empfangsbereich mit elegantem Design",

  "process.tag": "IHR WEG ZU UNS",
  "process.heading": "Ihr medizinischer Weg, stressfrei",
  "process.subtitle": "Wir begleiten Sie in jeder Phase und garantieren eine sichere, komfortable und erfolgreiche Erfahrung bei der Esteva Clinic.",
  "process.step1.title": "Beratung",
  "process.step1.desc": "Wir verstehen Ihre medizinischen Bedürfnisse, Ihre Klinikgeschichte und Ihre Erwartungen in einer ersten Online-Konsultation mit unseren Spezialisten.",
  "process.step2.title": "Personalisierte Planung",
  "process.step2.desc": "Wir erstellen einen maßgeschneiderten Behandlungsplan, der alle Details der Prozedur, Zeiten, Kosten und die komplette Reiseorganisation umfasst.",
  "process.step3.title": "Medizinische Überprüfung & Vorbereitung",
  "process.step3.desc": "Unser Team analysiert Ihre medizinischen Unterlagen und bereitet jedes Detail im Voraus vor – inklusive Dokumente, Reise und Unterkunft.",
  "process.step4.title": "Behandlung & Pflege",
  "process.step4.desc": "Sie erhalten eine hochwertige Behandlung in der Esteva Clinic mit maximaler Aufmerksamkeit und einem komfortablen Erlebnis.",
  "process.step5.title": "Follow-up & Support",
  "process.step5.desc": "Wir bleiben auch nach der Behandlung an Ihrer Seite, bieten kontinuierlichen Support und Anleitung für eine optimale Genesung.",
  "trust.heading_line1": "Wir verwandeln die",
  "trust.heading_line2": "Behandlung in ein Erlebnis des Vertrauens.",
  "trust.subtitle": "Vertrauen Sie dem Team der Esteva Clinic für hochwertige medizinische Betreuung, personalisierte Behandlungen und umfassenden Support während Ihres gesamten Heilungsprozesses.",
  "trust.check1": "Spezialisierte medizinische Beratung",
  "trust.check2": "Fortschrittliche Check-ups und Diagnostik",
  "trust.check3": "Allgemeine und spezialisierte Chirurgie",
  "trust.check4": "Personalisierte Behandlungen für internationale Patienten",
  "trust.check5": "Dedizierter Support für medizinischen Tourismus",
  "trust.check6": "Support vor, während und nach der Behandlung",

  "dental.tag": "DENTAL-EXPERTISE",
  "dental.heading": "Dein neues Lächeln beginnt hier",
  "dental.subtitle": "Moderne Lösungen für Ihr Lächeln: Zahnimplantate, All-on-4 / All-on-6 / All-on-8, Smile Design, mit hochwertigen Materialien und natürlichen Ergebnissen.",
  "dental.implant.title": "Premium Zahnimplantate",
  "dental.implant.desc": "Titan-Implantate, widerstandsfähig und natürlich, um die Funktion und Ästhetik Ihres Lächelns langfristig wiederherzustellen.",
  "dental.crown.title": "Zirkonkronen",
  "dental.crown.desc": "Ästhetische und widerstandsfähige Zirkonkronen, entwickelt für ein natürliches und langlebiges Ergebnis.",
  "dental.veneer.title": "Dental-Veneers",
  "dental.veneer.desc": "Dünne, natürliche ästhetische Veneers, ideal zur Korrektur von Form, Farbe und Ausrichtung der Zähne.",
  "dental.allon4.title": "All-on-4",
  "dental.allon4.desc": "Innovative Lösung mit 4 Zahnimplantaten pro Kiefer, die feste, stabile und natürliche Zähne ermöglicht.",
  "dental.allon6.title": "All-on-6",
  "dental.allon6.desc": "Fortschrittliche Technik mit 6 Zahnimplantaten pro Kiefer, die maximale Stabilität und Funktionalität garantiert.",
  "dental.allon8.title": "All-on-8",
  "dental.allon8.desc": "Komplettlösung mit 8 Zahnimplantaten pro Kiefer, ideal für maximalen Halt und 100% Funktionalität.",
  "dental.pterygoid.title": "Pterygoid-Implantate",
  "dental.pterygoid.desc": "Fortschrittliche Technik, die Pterygoid-Implantate nutzt, um Knochenaufbau zu vermeiden und feste Zähne auch bei komplexen Fällen mit wenig Knochen zu ermöglichen.",
  "dental.zygomatic.title": "Zygomatische Implantate",
  "dental.zygomatic.desc": "Fortgeschrittene Lösung mit zygomatischen Implantaten für Patienten mit starkem Knochenabbau, vermeidet Knochenaufbau und garantiert sofortige Stabilität und langfristige Ergebnisse.",
  "dental.maxillofacial.title": "Kiefer-Gesichts-Chirurgie",
  "dental.maxillofacial.desc": "Spezialisierte Eingriffe zur Behandlung komplexer Probleme von Mund, Kiefer und Gesicht, mit modernen Techniken und höchster Sicherheit.",
  "dental.cta": "Mehr erfahren",
  "overview.tag": "UNSERE FACHBEREICHE",
  "overview.heading": "Drei Disziplinen. Ein Anspruch.",
  "overview.subtitle": "Zahnmedizin, plastische Chirurgie und Haartransplantation — jedes Fachgebiet mit international erfahrenen Spezialisten, modernster Technik und einem Ziel: Ihre natürliche Schönheit.",
  "overview.dental.title": "Zahnmedizin",
  "overview.dental.desc": "Von einzelnen Implantaten bis zur kompletten Mundsanierung. Modernste 3D-Diagnostik, hochwertige Materialien und ein Team aus erfahrenen Implantologen für Ihr neues Lächeln.",
  "overview.dental.treatments": "Implantate, Zirkonkronen, Veneers, All-on-4/6/8, Bleaching, Zahnspangen, Knochenaufbau, Sinus Lift, Pterygoid & Zygomatische Implantate",
  "overview.surgery.title": "Plastische Chirurgie",
  "overview.surgery.desc": "Ästhetische Eingriffe auf höchstem Niveau. Von der Nasenkorrektur über Facelifting bis zur Körperformung — individuelle Konzepte mit maximaler Sicherheit und natürlichen Ergebnissen.",
  "overview.surgery.treatments": "Nasenkorrektur, Facelifting, Brustvergrößerung & -verkleinerung, Lidstraffung, Liposuktion, Bauchdeckenstraffung, Oberarm- & Oberschenkelstraffung, Magenballon",
  "overview.hair.title": "Haartransplantation",
  "overview.hair.desc": "Modernste FUE-Mikropunktur-Technik für ein natürlich dichtes, narbenfreies Ergebnis. Bis 5.000 Grafts in einer Sitzung — mit kostenloser Haaranalyse und persönlichem Behandlungsplan.",
  "overview.hair.treatments": "FUE Haartransplantation (bis 5.000 Grafts), kostenlose Haaranalyse, personalisierter Behandlungsplan, dauerhaft natürliches Ergebnis",
  "overview.cta": "Alle Behandlungen & Preise",
  "implants.hero_title": "Premium Zahnimplantate in Albanien",
  "implants.hero_subtitle": "Genießen Sie wieder das Lachen, Kauen und Sprechen mit Sicherheit dank unserer Premium-Zahnimplantate bei der Esteva Clinic.",
  "implants.hero_desc": "Wir bieten moderne, sichere und personalisierte Implantatlösungen für Patienten, die Qualität, Ästhetik und langfristige Stabilität suchen.",
  "implants.why_title": "Warum unsere Zahnimplantate wählen?",
  "implants.why_intro": "Zahnimplantate sind eine feste und dauerhafte Lösung zum Ersatz fehlender oder stark geschädigter Zähne. Bei der Esteva Clinic wird jeder Fall mit Sorgfalt untersucht, um eine sichere, ästhetische und funktionelle Behandlung zu bieten.",
  "implants.benefit1_title": "Premium-Materialien",
  "implants.benefit1_desc": "Wir verwenden sorgfältig ausgewählte Materialien, um Widerstandsfähigkeit, Biokompatibilität und langfristige Zuverlässigkeit zu garantieren.",
  "implants.benefit2_title": "Persönlicher Behandlungsplan",
  "implants.benefit2_desc": "Jeder Patient erhält eine individuelle Bewertung und einen Behandlungsplan, der auf seinen Bedürfnissen basiert.",
  "implants.benefit3_title": "Natürliche Ästhetik",
  "implants.benefit3_desc": "Ziel ist es, feste, schöne und natürliche Zähne zu erhalten, die im Einklang mit dem Lächeln des Patienten stehen.",
  "implants.when_title": "Wann sind Zahnimplantate indiziert?",
  "implants.when_desc": "Zahnimplantate sind indiziert, wenn ein oder mehrere Zähne fehlen, wenn natürliche Zähne nicht mehr gerettet werden können oder wenn eine herausnehmbare Prothese keine Stabilität und keinen Komfort bietet.",
  "implants.when_desc2": "Sie können verwendet werden, um einen einzelnen Zahn, mehrere Zähne oder einen ganzen Kiefer mit festen Lösungen wie All-on-4, All-on-6 oder Toronto Bridge zu ersetzen.",
  "implants.path_title": "Unser Implantat-Weg",
  "implants.path_step1_title": "1. Bewertung",
  "implants.path_step1_desc": "Analyse des Falls, Fachberatung und Untersuchung der Zahnsituation.",
  "implants.path_step2_title": "2. Behandlungsplan",
  "implants.path_step2_desc": "Erstellung eines personalisierten Plans mit Zeiten, Materialien und klaren Kosten.",
  "implants.path_step3_title": "3. Implantat-Einsetzung",
  "implants.path_step3_desc": "Durchführung durch ein erfahrenes medizinisches Team in sicherer und kontrollierter Umgebung.",
  "implants.path_step4_title": "4. Feste Zähne",
  "implants.path_step4_desc": "Herstellung der finalen Prothese für ein stabiles, funktionales und ästhetisches Lächeln.",
  "implants.cta_title": "Fordern Sie eine personalisierte Bewertung an",
  "implants.cta_desc": "Senden Sie ein Panorama-Röntgenbild oder kontaktieren Sie uns für eine erste Bewertung. Unser Team wird Sie zur besten Lösung für Ihren Fall führen.",
  "implants.cta_button": "Jetzt Termin vereinbaren",

  "imprint.title": "Impressum",
  "imprint.responsible": "Verantwortlich für den Inhalt",
  "imprint.address_label": "Adresse",
  "imprint.phone_label": "Telefon",
  "imprint.email_label": "E-Mail",
  "imprint.authorized_label": "Vertretungsberechtigte",
  "imprint.register_label": "Handelsregister",
  "imprint.vat_label": "Umsatzsteuer-ID",
  "imprint.disclaimer_title": "Haftungsausschluss",
  "imprint.disclaimer_text": "Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
  "imprint.copyright_title": "Urheberrecht",
  "imprint.copyright_text": "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
  "imprint.data_protection_link": "Zur Datenschutzerklärung",

  "booking.find_us": "SO FINDEN SIE UNS",
  "booking.visit_us": "Besuchen Sie uns in Tirana",
  "booking.visit_subtitle": "Unsere Klinik befindet sich im Herzen von Tirana. Vereinbaren Sie einen Termin und lernen Sie uns persönlich kennen.",

  "agb.title": "AGB",
  "agb.meta_desc": "Allgemeine Geschäftsbedingungen der Vermittlungsplattform Esteva.ch. Informationen zu Geltungsbereich, Haftung, Leistungen und anwendbarem Recht.",

  "hero.discover_prices": "Preise entdecken",

  "services.hero_subtitle": "Drei Disziplinen, ein Anspruch: absolute Perfektion. Zahnmedizin, plastische Chirurgie und Haartransplantation im Herzen von Tirana – bis 70% günstiger als in DE/AT/CH.",
  "services.page_cta_title": "Bereit für Ihre Transformation?",
  "services.page_cta_subtitle": "Vereinbaren Sie jetzt Ihr persönliches Beratungsgespräch in Tirana. Unser Expertenteam erstellt ein maßgeschneidertes Behandlungskonzept – ganz auf Ihre Wünsche abgestimmt.",

  "testimonials.hero_subtitle": "Echte Transformationen, echte Emotionen. Unsere Kunden kommen aus ganz Europa nach Tirana — und gehen mit einem neuen Lebensgefühl.",
  "testimonials.rating": "★ 4.9 / 5.0 — basierend auf über 240 Bewertungen unserer Kunden aus ganz Europa. Jede Bewertung ist verifiziert.",
  "testimonials.cta_title": "Werden Sie Teil unserer Erfolgsgeschichten",
  "testimonials.cta_subtitle": "Ihre Transformation beginnt mit einem Gespräch. Lassen Sie uns gemeinsam herausfinden, wie wir Ihre natürliche Schönheit unterstreichen können.",
  "testimonials.hero_tag": "ECHTE ERFAHRUNGEN",
  "testimonials.filter_all": "Alle",
  "testimonials.filter_dental": "Zahnmedizin",
  "testimonials.filter_surgery": "Chirurgie",
  "testimonials.filter_hair": "Haartransplantation",
  "testimonials.based_on": "Basierend auf {{count}} verifizierten Bewertungen",
  "testimonials.rating_breakdown": "Bewertungsverteilung",
  "testimonials.verified": "Verifiziert",
  "testimonials.time_ago_months": "vor {{count}} Monaten",
  "testimonials.time_ago_months_one": "vor 1 Monat",
  "testimonials.time_ago_years": "vor {{count}} Jahren",
  "testimonials.time_ago_years_plural": "vor {{count}} Jahren",
  "testimonials.empty_title": "Keine Bewertungen in dieser Kategorie",
  "testimonials.empty_subtitle": "Schauen Sie in einer anderen Kategorie oder lesen Sie alle Bewertungen.",

  "about.vision_title": "Eine Vision, geboren am Mittelmeer",
  "about.vision_para2": "Gegründet von Dr. Nertila Basha, einer international ausgebildeten Spezialistin für ästhetische Medizin, vereint Esteva Clinic das Beste aus zwei Welten: die Präzision und das Know-how internationaler Spitzenmedizin mit der herzlichen, authentischen Gastfreundschaft des Balkans. Unser Team aus 11 Experten — darunter Fachärzte für Haarchirurgie, Dental-Kosmetik und ästhetische Medizin — arbeitet Hand in Hand, um für jeden Kunden das optimale Ergebnis zu erzielen.",
  "about.meet_team_link": "Unser Team kennenlernen",
  "about.albania_title": "Albanien — ein Land im Aufbruch",
  "about.albania_subtitle": "Tirana ist längst kein Geheimtipp mehr. Die albanische Hauptstadt entwickelt sich rasant zu einem der dynamischsten Wirtschafts- und Kulturzentren Südosteuropas — und Esteva Clinic ist mittendrin.",
  "about.albania_card1_title": "Wirtschaftswunder am Balkan",
  "about.albania_card1_desc": "Albanien verzeichnet seit Jahren Rekordwachstum. Internationale Investitionen, moderne Infrastruktur und eine junge, hochmotivierte Bevölkerung machen Tirana zum Hotspot für Innovation und Fortschritt.",
  "about.albania_card2_title": "Natur, die begeistert",
  "about.albania_card2_desc": "Von der türkisblauen Adria im Westen bis zu den majestätischen Albanischen Alpen im Norden — Albanien vereint mediterrane Leichtigkeit mit alpiner Grandezza auf engstem Raum.",
  "about.albania_card3_title": "Europas neuer Magnet",
  "about.albania_card3_desc": "Immer mehr Reisende, Digital Nomads und internationale Unternehmen entdecken Albanien. Tirana wurde vom Time Magazine zu einer der spannendsten Städte der Welt gekürt.",
  "about.experience_title": "Erleben Sie Esteva Clinic selbst",
  "about.experience_subtitle": "Besuchen Sie uns in Tirana. Oder starten Sie mit einem persönlichen Beratungsgespräch — vor Ort oder online.",

  "booking.form_name_label": "Name",
  "booking.form_name_placeholder": "Ihr vollständiger Name",
  "booking.form_phone_short": "Telefon",
  "booking.form_treatment_label": "Gewünschte Behandlung",
  "booking.form_message_optional": "Nachricht (optional)",
  "booking.form_select_please": "Bitte wählen",
  "booking.form_message_short_placeholder": "Ihre Nachricht an uns...",
  "booking.opening_hours_label": "Öffnungszeiten",
  "booking.day_mofr": "Mo – Fr",
  "booking.day_saturday": "Samstag",
  "booking.day_sunday": "Sonntag",
  "booking.day_closed": "Geschlossen",
  "booking.albania_text": "Albanien",

  "contact.hero_tag": "Wir sind für Sie da",
  "contact.hero_title_line1": "Schreiben Sie uns.",
  "contact.hero_title_line2": "Wir antworten innerhalb 24h.",
  "contact.hero_subtitle": "Kostenlose Erstberatung, Preisanfragen oder einfach Fragen — das Esteva-Team freut sich auf Ihre Nachricht.",
  "contact.form_title": "Nachricht senden",
  "contact.form_required_hint": "Alle Felder mit * sind Pflichtfelder.",
  "contact.firstname_label": "Vorname",
  "contact.lastname_label": "Nachname",
  "contact.phone_optional": "Telefon",
  "contact.subject_label": "Betreff",
  "contact.subject_placeholder": "Bitte wählen...",
  "contact.subject_dental": "Zahnmedizin & Implantate",
  "contact.subject_surgery": "Plastische Chirurgie",
  "contact.subject_hair": "Haartransplantation",
  "contact.subject_general": "Allgemeine Beratung",
  "contact.subject_price": "Preisanfrage",
  "contact.subject_other": "Sonstiges",
  "contact.message_label": "Ihre Nachricht",
  "contact.message_max": "(max. 500 Zeichen)",
  "contact.privacy_contact": "Ich habe die Datenschutzerklärung gelesen und bin damit einverstanden, dass meine Daten zur Bearbeitung meiner Anfrage verwendet werden.",
  "contact.sending": "Wird gesendet...",
  "contact.submit": "Nachricht absenden",
  "contact.success_title": "Vielen Dank!",
  "contact.success_message": "Ihre Nachricht ist bei uns eingegangen. Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
  "contact.new_message": "Neue Nachricht senden",
  "contact.info_title": "Kontaktinformationen",
  "contact.follow_us": "Folgen Sie uns",
  "contact.book_title": "Lieber direkt?",
  "contact.book_online": "Termin online buchen",
  "contact.book_free": "Kostenlose Erstberatung",
  "contact.maps_open": "In Google Maps öffnen",
  "contact.find_us_label": "SO FINDEN SIE UNS",
  "contact.opening_hours": "Öffnungszeiten",
  "contact.address_label": "Adresse",
  "contact.monday_friday": "Mo – Fr",
  "contact.saturday": "Samstag",
  "contact.sunday": "Sonntag",
  "contact.closed": "Geschlossen",
  "instagram.followers": "Follower",
  "instagram.posts": "Beiträge",
  "instagram.likes_label": "Likes",

  // ══════════════════════════════════════════
  // SEO Meta-Tags – mehrsprachig
  // ══════════════════════════════════════════
  "seo.ogLocale": "de_DE",
  "seo.home.title": "Esteva Clinic – Premium Schönheitsklinik & Zahnklinik Tirana | Zahnimplantate, Haartransplantation, Plastische Chirurgie – Bis 70% günstiger",
  "seo.home.description": "Esteva Clinic ist Ihre Premium-Schönheitsklinik und Zahnklinik in Tirana, Albanien. Wir bieten das komplette Spektrum der ästhetischen Medizin: Zahnimplantate, Zirkonkronen, Veneers, Haartransplantation (FUE), Brustvergrösserung, Nasenkorrektur, Facelifting, Botox, Hyaluron Filler, Liposuktion, Bauchdeckenstraffung und weitere Eingriffe. Alle Behandlungen bis zu 70% günstiger als in der Schweiz, Deutschland und Österreich. International ausgebildete Spezialisten sprechen Deutsch. Kostenlose Erstberatung.",
  "seo.home.keywords": "Zahnimplantate Albanien, Zirkonkronen, Veneers, Zahnbleaching, Zahnprothese, Brücken Zähne, Haartransplantation Albanien, FUE Haartransplantation, Haartransplantation günstig, Brustvergrösserung Albanien, Brustimplantate günstig, Nasenkorrektur Albanien, Rhinoplastik günstig, Nasenoperation Ausland, Augenlidkorrektur, Facelifting Albanien, Bauchdeckenstraffung, Liposuktion Albanien, Fettabsaugung günstig, Botox Albanien, Hyaluron Filler, Lippenaufspritzung, Faltenbehandlung, BBL Brazil Butt Lift, Intimchirurgie, Ohrenkorrektur, Bruststraffung, Brustverkleinerung, Oberarmstraffung, Oberschenkelstraffung, Plastische Chirurgie Albanien, Schönheitsoperation Ausland, Ästhetische Chirurgie Tirana, Medical Tourism Albania, Dental Tourismus, Premium Klinik Tirana, 70% günstiger Schweiz, 70% günstiger Deutschland, Zahnarzt Ausland, Schönheitsklinik Tirana, Günstige Schönheits-OP Schweiz, Kostenlose Erstberatung, Esteva Clinic, Euromed Tirana",
  "seo.home.seo_text": "Esteva Clinic ist Ihre Premium-Schönheitsklinik und Zahnklinik in Tirana, Albanien. Wir bieten das komplette Spektrum der ästhetischen Medizin: Zahnimplantate, Zirkonkronen, Veneers, Haartransplantation (FUE), Brustvergrösserung, Bruststraffung, Brustverkleinerung, Nasenkorrektur (Rhinoplastik), Facelifting, Botox, Hyaluron Filler, Liposuktion, Bauchdeckenstraffung, Augenlidkorrektur und weitere plastisch-chirurgische Eingriffe. Alle Behandlungen bis zu 70% günstiger als in der Schweiz, Deutschland und Österreich — bei gleichem oder höherem medizinischen Standard. Unsere Spezialisten sind international ausgebildet und sprechen Deutsch. Patienten aus Zürich, Basel, Bern, Genf, Wien, München, Frankfurt, Berlin und der gesamten DACH-Region kommen zu uns. Wir übernehmen Flugplanung, Hoteltransfer und Nachsorge. Kostenlose Erstberatung — jetzt Termin vereinbaren.",
  "seo.about.title": "Über uns – Esteva Clinic | Premium Schönheitsklinik & Zahnklinik in Tirana, Albanien",
  "seo.about.description": "Esteva Clinic in Tirana, Albanien: Unsere Geschichte, Philosophie und unser internationales Expertenteam. Entdecken Sie, warum wir die erste Adresse für Premium-Ästhetik im Herzen des Balkans sind. Zahnimplantate, Haartransplantation, plastische Chirurgie — bis 70% günstiger als in DE/AT/CH.",
  "seo.about.keywords": "Esteva Clinic, Premium Klinik Tirana, Ästhetische Chirurgie Tirana, Schönheitsklinik Tirana, Medical Tourism Albania, plastische Chirurgie Albanien, Zahnmedizin Albanien",
  "seo.services.title": "Leistungen – Esteva Clinic | Zahnmedizin, Plastische Chirurgie & Haartransplantation Tirana",
  "seo.services.description": "Esteva Clinic Leistungen in Tirana: Premium Zahnmedizin mit Zahnimplantaten, Veneers, Zirkonkronen. Plastische Chirurgie: Nasenkorrektur, Brustvergrösserung, Facelifting, Liposuktion. FUE Haartransplantation bis 5.000 Grafts. Bis 70% günstiger als in DE/AT/CH. Internationales Expertenteam.",
  "seo.services.keywords": "Zahnimplantate Albanien, Zirkonkronen, Veneers, Haartransplantation Albanien, FUE Haartransplantation, Brustvergrösserung Albanien, Nasenkorrektur Albanien, Facelifting Albanien, Liposuktion Albanien, Botox Albanien, Hyaluron Filler, Plastische Chirurgie Albanien, Esteva Clinic Leistungen",
  "seo.pricing.title": "Preisliste – Esteva Clinic Tirana | Zahnimplantate, Chirurgie & Haartransplantation Kosten",
  "seo.pricing.description": "Komplette Preisliste der Esteva Clinic Tirana: Zahnimplantate ab 350 €, Zirkonkronen, Veneers. Rhinoplastik ab 2.200 €, Brustvergrösserung ab 4.200 €, Facelifting ab 4.200 €, Liposuktion, FUE Haartransplantation ab 1.500 €. Alle Preise mit Hotel & Transfer inklusive. Bis 70% günstiger als in DE/AT/CH.",
  "seo.pricing.keywords": "Zahnimplantate Kosten, Zirkonkronen Preis, Veneers Kosten, Haartransplantation günstig, FUE Haartransplantation Preis, Rhinoplastik günstig, Brustimplantate günstig, Nasenoperation Ausland, Fettabsaugung günstig, Liposuktion Kosten, Facelifting Preis, Günstige Schönheits-OP Schweiz, Preisliste Dental Tirana, Preisliste Chirurgie Albanien, Esteva Clinic Preise",
  "seo.testimonials.title": "Bewertungen – Esteva Clinic | Echte Patientenerfahrungen Zahnmedizin & Chirurgie Tirana",
  "seo.testimonials.description": "Echte Bewertungen von Esteva Clinic Patienten: Zahnimplantate, Veneers, Nasenkorrektur, Facelifting, Haartransplantation in Tirana. Lesen Sie Erfahrungsberichte aus Zürich, München, Wien. Bis 70% günstiger — Premium-Ergebnisse.",
  "seo.testimonials.keywords": "Esteva Clinic Bewertungen, Zahnimplantate Erfahrungen, Nasenkorrektur Erfahrungsberichte, Facelifting Bewertungen, Haartransplantation Erfahrungen, Veneers Bewertungen, Patientenstimmen ästhetische Medizin, Schönheits-OP Erfahrungen Ausland",
  "seo.booking.title": "Termin buchen – Esteva Clinic | Kostenlose Erstberatung Tirana",
  "seo.booking.description": "Vereinbaren Sie Ihre kostenlose Erstberatung bei Esteva Clinic in Tirana. Zahnimplantate, Haartransplantation, plastische Chirurgie & ästhetische Medizin. Termin online buchen — wir melden uns innerhalb 24h. Bis 70% günstiger als in DE/AT/CH.",
  "seo.booking.keywords": "Termin buchen Tirana, Kostenlose Erstberatung, Esteva Clinic Buchung, Beratungstermin Schönheitsklinik, Zahnarzt Ausland Termin, Schönheits-OP Beratung, Haartransplantation Beratung",
  "seo.gallery.title": "Galerie Vorher-Nachher – Esteva Clinic | Ergebnisse Zahnmedizin & Chirurgie Tirana",
  "seo.gallery.description": "Beeindruckende Vorher-Nachher Ergebnisse der Esteva Clinic in Tirana: Zahnimplantate, Veneers, Nasenkorrektur, Facelifting, Brustvergrösserung, Haartransplantation. Echte Transformationen — bis 70% günstiger als in DE/AT/CH.",
  "seo.gallery.keywords": "Vorher Nachher Galerie, Zahnimplantate Ergebnisse, Veneers Resultate, Nasenkorrektur Transformation, Facelifting Vorher Nachher, Haartransplantation Ergebnisse, ästhetische Chirurgie Resultate, Esteva Clinic Galerie",
  "seo.team.title": "Team – Esteva Clinic | Internationale Spezialisten für ästhetische Medizin Tirana",
  "seo.team.description": "Lernen Sie das internationale Expertenteam der Esteva Clinic in Tirana kennen. Spezialisten für Zahnimplantate, plastische Chirurgie, Haartransplantation & ästhetische Medizin. Mehrsprachig, erfahren, leidenschaftlich. Deutschsprachige Betreuung.",
  "seo.team.keywords": "Esteva Clinic Team, plastische Chirurgen Tirana, Zahnmedizin Experten Albanien, Implantologe Tirana, Haarchirurg Albanien, Spezialisten ästhetische Medizin, Ärzte Schönheitsklinik Tirana",
  "seo.contact.title": "Kontakt – Esteva Clinic | Kostenlose Erstberatung Tirana",
  "seo.contact.description": "Nehmen Sie Kontakt mit der Esteva Clinic in Tirana auf. Kostenlose Erstberatung für Zahnimplantate, Haartransplantation, plastische Chirurgie & ästhetische Medizin. Wir sprechen Deutsch. Jetzt Anfrage senden — Antwort innerhalb 24h.",
  "seo.contact.keywords": "Kontakt Esteva Clinic, Kostenlose Erstberatung Tirana, Beratung Zahnimplantate, Schönheitsklinik Tirana Kontakt, Anfrage Schönheits-OP, Zahnarzt Ausland Beratung, Medical Tourism Albania Kontakt",
  "seo.dental_implants.title": "Zahnimplantate Albanien – Esteva Clinic | Premium Zahnmedizin Tirana",
  "seo.dental_implants.description": "Premium Zahnimplantate in Tirana, Albanien. Zirkonkronen, Veneers, All-on-4, All-on-6, All-on-8. Moderne 3D-Diagnostik, erfahrene Implantologen. Bis 70% günstiger als in DE/AT/CH. Inkl. Hotel, Transfer & 3D-Scan. Kostenlose Erstberatung.",
  "seo.dental_implants.keywords": "Zahnimplantate Albanien, Zirkonkronen Tirana, Veneers Albanien, All-on-4 Tirana, All-on-6 Albanien, Zahnprothese Ausland, Dental Tourismus Albanien, Zahnarzt Ausland, Zahnimplantat Kosten, Esteva Clinic Implantate",
  "seo.agb.keywords": "AGB, Esteva Clinic, Terms, Bedingungen, Esteva.ch",

  // ══════════════════════════════════════════
  // Datenschutzerklärung – Privacy Policy
  // ══════════════════════════════════════════
  "privacy.title": "Datenschutzerklärung",
  "privacy.subtitle": "Esteva.ch — Vermittlungsplattform für medizinische und ästhetische Dienstleistungen",
  "privacy.date": "Stand: 11. Juni 2026",
  "privacy.last_updated": "Letzte Aktualisierung",
  "privacy.s1_title": "1. Verantwortliche Stelle",
  "privacy.s1_text": "Verantwortlich für die Datenbearbeitung auf dieser Plattform ist:\n\nAI Vision GmbH\nUnterdorf 8, 8222 Beringen, Schweiz\nE-Mail: info@esteva.ch\n(Vermittler / Plattformbetreiber)\n\nFür die Verarbeitung Ihrer medizinischen Anfragen mitverantwortlich:\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albanien\n\nDiese Datenschutzerklärung gilt gemäss dem schweizerischen Datenschutzgesetz (DSG/revDSG) sowie, soweit anwendbar, der Datenschutz-Grundverordnung der EU (DSGVO).",
  "privacy.s2_title": "2. Welche Daten wir erheben",
  "privacy.s2_text": "Wir erheben folgende Kategorien von Personendaten:\n\n• Kontaktdaten: Name, E-Mail-Adresse, Telefonnummer\n• Behandlungswunsch und -anfragen (von Ihnen freiwillig mitgeteilt)\n• Technische Daten: IP-Adresse, Browser-Typ, Besuchszeit, aufgerufene Seiten\n• Kommunikationsdaten: Nachrichten über Kontaktformulare oder WhatsApp\n\nWir erheben keine besonderen Kategorien von Personendaten (z.B. Gesundheitsdaten) ohne Ihre ausdrückliche Einwilligung.",
  "privacy.s3_title": "3. Zweck der Datenbearbeitung",
  "privacy.s3_text": "Ihre Daten werden ausschliesslich für folgende Zwecke verwendet:\n\n• Vermittlung an den gewünschten Leistungserbringer (Klinik)\n• Beantwortung von Anfragen und Terminvereinbarungen\n• Verbesserung der Plattform und technische Verwaltung\n• Einhaltung gesetzlicher Pflichten",
  "privacy.s4_title": "4. Weitergabe von Daten",
  "privacy.s4_text": "4.1 Ihre Kontaktdaten und Ihr Behandlungswunsch werden an den von Ihnen ausgewählten Leistungserbringer (Klinik in Albanien) weitergegeben, damit dieser Ihre Anfrage bearbeiten kann.\n\n4.2 Wir geben Ihre Daten nicht an Dritte zu kommerziellen Zwecken weiter.\n\n4.3 Eine Datenübermittlung ins Ausland (Albanien) erfolgt auf Basis Ihrer Einwilligung. Albanien gilt nicht als Land mit einem dem schweizerischen gleichwertigen Datenschutzniveau; die Übermittlung erfolgt gestützt auf Ihre ausdrückliche Einwilligung gemäss Art. 17 revDSG.",
  "privacy.s5_title": "5. Cookies und Tracking",
  "privacy.s5_text": "5.1 Unsere Plattform verwendet technisch notwendige Cookies für den Betrieb der Website.\n\n5.2 Wir können Analyse-Tools (z.B. Google Analytics) einsetzen. Sie können der Verwendung von Analyse-Cookies jederzeit widersprechen.\n\n5.3 Sie können Cookies in Ihren Browser-Einstellungen deaktivieren; dies kann die Funktionalität der Plattform einschränken.",
  "privacy.s6_title": "6. Aufbewahrungsdauer",
  "privacy.s6_text": "Wir speichern Ihre Personendaten nur so lange, wie es für die genannten Zwecke erforderlich ist. Anfragedaten werden nach spätestens 2 Jahren gelöscht.",
  "privacy.s7_title": "7. Ihre Rechte",
  "privacy.s7_text": "Sie haben folgende Rechte bezüglich Ihrer Personendaten:\n\n• Auskunftsrecht: Auskunft über gespeicherte Daten\n• Berichtigungsrecht: Berichtigung unrichtiger Daten\n• Löschungsrecht: Löschung Ihrer Daten soweit keine gesetzlichen Pflichten entgegenstehen\n• Widerspruchsrecht: Widerspruch gegen die Datenbearbeitung\n• Datenübertragbarkeit: Herausgabe Ihrer Daten in einem gängigen Format\n\nZur Ausübung Ihrer Rechte: info@esteva.ch\n\nBeschwerden können Sie beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB) einreichen: www.edoeb.admin.ch",
  "privacy.s8_title": "8. Datensicherheit",
  "privacy.s8_text": "Wir treffen angemessene technische und organisatorische Massnahmen zum Schutz Ihrer Personendaten (z.B. SSL/TLS-Verschlüsselung).",
  "privacy.s9_title": "9. Drittdienste",
  "privacy.s9_text": "Die Plattform kann folgende Drittdienste einsetzen:\n\n• Google Maps — Datenschutzrichtlinie: policies.google.com/privacy\n• WhatsApp Business — Datenschutzrichtlinie: www.whatsapp.com/legal/privacy-policy",
  "privacy.s10_title": "10. Änderungen dieser Datenschutzerklärung",
  "privacy.s10_text": "Wir behalten uns vor, diese Datenschutzerklärung jederzeit anzupassen. Die aktuelle Fassung ist auf www.Esteva.ch abrufbar.\n\nAI Vision GmbH | Unterdorf 8, 8222 Beringen | info@esteva.ch | www.Esteva.ch",

  // SEO
  "seo.privacy.title": "Datenschutzerklärung – Esteva.ch | AI Vision GmbH, Beringen, Schweiz",
  "seo.privacy.description": "Datenschutzerklärung der Vermittlungsplattform Esteva.ch. Informationen zur Erhebung, Verarbeitung und Weitergabe von Personendaten gemäss schweizerischem DSG/revDSG und EU-DSGVO. Verantwortliche Stelle: AI Vision GmbH, Beringen, Schweiz.",
  "seo.privacy.keywords": "Datenschutzerklärung, Esteva.ch, AI Vision GmbH, Datenschutz, DSG, revDSG, DSGVO, Personendaten, Beringen, Schweiz",

  // ══════════════════════════════════════════
  // Admin-Dashboard
  // ══════════════════════════════════════════
  "admin.logo": "ESTEVA ADMIN",
  "admin.to_website": "Zur Website",
  "admin.logout": "Abmelden",
  "admin.sidebar_expand": "Sidebar ausklappen",
  "admin.sidebar_collapse": "Sidebar einklappen",
  "admin.nav_dashboard": "Übersicht",
  "admin.nav_pages": "Seiten & Inhalte",
  "admin.nav_treatments": "Behandlungen & Preise",
  "admin.nav_team": "Team",
  "admin.nav_reviews": "Bewertungen",
  "admin.nav_bookings": "Buchungen & Termine",
  "admin.nav_newsletter": "Newsletter",
  "admin.nav_media": "Bilder & Medien",
  "admin.nav_translations": "Sprachen & Übersetzungen",
  "admin.nav_footer": "Footer & Kontakt",
  "admin.nav_seo": "SEO",
  "admin.nav_settings": "Einstellungen",
  "admin.breadcrumb_admin": "Admin",
  "admin.header_settings": "Einstellungen",

  "admin.dashboard_title": "Dashboard",
  "admin.dashboard_welcome": "Willkommen zurück! Hier ist Ihre Übersicht.",
  "admin.stat_bookings": "Buchungen",
  "admin.stat_bookings_sub": "{{count}} neu",
  "admin.stat_confirmed": "Bestätigt",
  "admin.stat_confirmed_sub": "aktiv",
  "admin.stat_today": "Heute",
  "admin.stat_today_sub": "Termine",
  "admin.stat_treatments": "Behandlungen",
  "admin.stat_treatments_sub": "Preislisten",
  "admin.stat_team": "Team",
  "admin.stat_team_sub": "Mitglieder",
  "admin.stat_reviews": "Bewertungen",
  "admin.stat_reviews_sub": "Kundenstimmen",

  "admin.upcoming_title": "Kommende Termine",
  "admin.today_label": "Heute",
  "admin.upcoming_label": "Demnächst",
  "admin.no_future_bookings": "Keine weiteren Termine geplant.",
  "admin.view_all": "Alle anzeigen",

  "admin.status_new": "Neu",
  "admin.status_confirmed": "Bestätigt",
  "admin.status_done": "Erledigt",

  "admin.activity_title": "Letzte Aktivitäten",
  "admin.activity_empty": "Noch keine Aktivitäten.",
  "admin.activity_just_now": "gerade eben",
  "admin.activity_min_ago": "vor {{count}} Min.",
  "admin.activity_hour_ago": "vor {{count}} Std.",
  "admin.activity_day_ago": "vor {{count}} Tag",
  "admin.activity_days_ago": "vor {{count}} Tagen",

  "admin.quick_title": "Schnellzugriff",
  "admin.quick_home": "Startseite bearbeiten",
  "admin.quick_bookings": "Buchungen verwalten",
  "admin.quick_pricing": "Preisliste bearbeiten",
  "admin.quick_team": "Team verwalten",

  "admin.service_hair": "Haartransplantation",
  "admin.service_dental": "Dental-Kosmetik",
  "admin.service_botox": "Botox & Filler",
  "admin.service_combined": "Kombi-Behandlung",
  "admin.service_consultation": "Beratung",

  "team.nertila-basha.title": "CEO, Zahnärztin, Implantologin & Prothetikerin",
  "team.nertila-basha.specialty": "Zahnimplantate & ästhetische Prothetik",
  "team.nertila-basha.bio": "Dr. Nertila Basha ist CEO und Zahnärztin, Implantologin und Prothetikerin mit umfassender Erfahrung im dentalen Bereich. Sie zeichnet sich durch klinische Präzision und Liebe zum Detail aus und bietet moderne, individuell angepasste Behandlungen für jeden Patienten. Ihr Ziel ist es, funktionale und ästhetische Ergebnisse auf höchstem Niveau zu garantieren, wobei stets die Gesundheit und das Wohlbefinden des Patienten im Mittelpunkt stehen.",
  "team.nertila-basha.certifications": ["Fachärztin für Zahnmedizin", "Implantologie & Prothetik", "Universität Tirana"],

  "team.denisa-zhegu.title": "Ärztin für Ästhetische Medizin",
  "team.denisa-zhegu.specialty": "Dermo-ästhetische Behandlungen",
  "team.denisa-zhegu.bio": "Dr. Denisa Zhegu ist Ärztin für ästhetische Medizin mit internationaler Ausbildung, spezialisiert auf fortschrittliche dermo-ästhetische Behandlungen. Sie zeichnet sich durch den Einsatz moderner und sicherer Techniken aus und bietet natürliche, individuell angepasste Ergebnisse für jeden Patienten. Dank ihrer Erfahrung und kontinuierlichen Weiterbildung ist sie eine feste Größe in der ästhetischen Medizin in Tirana.",
  "team.denisa-zhegu.certifications": ["Fachärztin Ästhetische Medizin", "Dermo-ästhetische Zertifizierung", "Internationale Akademie"],

  "team.nuri-qyra.title": "Anästhesist & Intensivmediziner",
  "team.nuri-qyra.specialty": "Anästhesie & Patientensicherheit",
  "team.nuri-qyra.bio": "Spezialist mit über 40 Jahren Erfahrung in Anästhesie und Intensivmedizin, der sich der Sicherheit, Überwachung und dem maximalen Komfort des Patienten während jeder medizinischen und chirurgischen Prozedur widmet. Seine Ruhe und Expertise geben Patienten und Team gleichermaßen Sicherheit.",
  "team.nuri-qyra.certifications": ["Facharzt Anästhesie", "Intensivmedizin", "Universität Tirana"],

  "team.nurie-paloka.title": "Leitende OP-Schwester",
  "team.nurie-paloka.specialty": "Chirurgische Assistenz & OP-Management",
  "team.nurie-paloka.bio": "Mit 37 Jahren Erfahrung in der chirurgischen Assistenz und im OP-Management ist sie dem höchsten Niveau an Professionalität, Organisation und Patientenversorgung während jeder medizinischen Prozedur gewidmet. Sie koordiniert den gesamten OP-Ablauf mit Präzision und Herz.",
  "team.nurie-paloka.certifications": ["Leitende OP-Schwester", "Chirurgische Assistenz", "Klinikmanagement"],

  "team.ermir-mehillej.title": "Chirurg Implantologe",
  "team.ermir-mehillej.specialty": "Zahnimplantologie & Chirurgie",
  "team.ermir-mehillej.bio": "Dr. Ermir Mehillej ist ein Zahnarzt und chirurgischer Implantologe mit 8 Jahren Erfahrung im Bereich. Er ist spezialisiert auf traditionelle Implantologie, pterygoide und zygomatische Implantate und bewältigt auch die komplexesten Fälle mit Präzision und Kompetenz. Dank seiner langjährigen Erfahrung bietet er sichere, funktionelle und ästhetisch fortschrittliche Lösungen für jeden Patienten.",
  "team.ermir-mehillej.certifications": ["Facharzt Zahnmedizin", "Implantologie-Chirurgie", "Zygomatische & Pterygoide Implantate"],

  "team.roel-ferataj.title": "Chirurg Implantologe",
  "team.roel-ferataj.specialty": "Zahnimplantologie & Chirurgie",
  "team.roel-ferataj.bio": "Dr. Roel Ferataj ist ein Zahnarzt und chirurgischer Implantologe mit 4 Jahren Erfahrung im Bereich. Er ist spezialisiert auf traditionelle Implantologie, pterygoide und zygomatische Implantate und zeichnet sich durch Präzision und Sorgfalt bei jeder Behandlung aus, auch in den komplexesten Fällen. Mit einem professionellen Ansatz und großer Aufmerksamkeit für die Bedürfnisse des Patienten bietet er moderne, sichere und ästhetisch harmonische Lösungen.",
  "team.roel-ferataj.certifications": ["Facharzt Zahnmedizin", "Implantologie-Chirurgie", "Fortgeschrittene Implantologie"],

  "team.ana-bardhi.title": "Zahnärztin für Prothetik & Endodontie",
  "team.ana-bardhi.specialty": "Prothetik, Endodontie & Ästhetische Rehabilitation",
  "team.ana-bardhi.bio": "Dr. Ana Bardhi ist eine Spezialistin für Zahnprothetik und Endodontie mit 6 Jahren klinischer Erfahrung. Sie kümmert sich um die ästhetische und funktionelle Rehabilitation des Lächelns und bietet personalisierte Behandlungen sowie moderne Lösungen für jeden Patienten. Dank ihrer Professionalität und Liebe zum Detail garantiert sie hochwertige Behandlungen in einem einladenden und sicheren Umfeld.",
  "team.ana-bardhi.certifications": ["Fachärztin Prothetik", "Endodontie-Spezialistin", "Ästhetische Zahnmedizin"],

  "team.rigers-xaka.title": "Dentalassistent",
  "team.rigers-xaka.specialty": "Klinische Assistenz & Patientenbetreuung",
  "team.rigers-xaka.bio": "Rigers Xaka ist ein Dentalassistent mit 2 Jahren Erfahrung im Dentalbereich. Er unterstützt das medizinische Team während klinischer Prozeduren und trägt dazu bei, ein organisiertes, sicheres und einladendes Umfeld für die Patienten zu gewährleisten. Dank seiner Professionalität und Aufmerksamkeit für Details sorgt er für eine effiziente Assistenz in jeder Phase der Behandlung.",
  "team.rigers-xaka.certifications": ["Dentalassistent", "Klinische Unterstützung", "Patientenmanagement"],

  "team.luciana-basha.title": "Endodontistin",
  "team.luciana-basha.specialty": "Wurzelkanalbehandlung & Erhalt natürlicher Zähne",
  "team.luciana-basha.bio": "Ärztin für Endodontie mit 3 Jahren Erfahrung in Wurzelkanalbehandlungen und der Erhaltung natürlicher Zähne. Sie widmet sich präzisen, minimalinvasiven und schmerzfreien Behandlungen, setzt moderne Techniken ein und stellt stets den Komfort und die Gesundheit des Patienten an erste Stelle.",
  "team.luciana-basha.certifications": ["Fachärztin Endodontie", "Wurzelkanalspezialistin", "Universität Tirana"],

  "team.gezim-kabashi.title": "Fahrer & Patientenbetreuung",
  "team.gezim-kabashi.specialty": "Organisatorische Unterstützung & Transport",
  "team.gezim-kabashi.bio": "Spezialisiert auf die umfassende Betreuung von Patienten während ihres gesamten Aufenthalts in Albanien. Er bietet organisatorische Unterstützung, professionelle Kommunikation und ein komfortables Erlebnis vom Moment der Ankunft bis zur Beendigung der Behandlung.",
  "team.gezim-kabashi.certifications": ["Patientenbetreuung", "Fahrer", "Organisationsmanagement"],

  "team.griselda.title": "Klinikkoordinatorin",
  "team.griselda.specialty": "Klinikmanagement & Patientenkoordination",
  "team.griselda.bio": "Griselda ist die Klinikkoordinatorin und verfügt über mehr als 10 Jahre Erfahrung in der Verwaltung und Koordination von Kliniken und Krankenhausstrukturen. Dank ihrer organisatorischen Fähigkeiten und ihrer Aufmerksamkeit für die Patienten garantiert sie einen effizienten, professionellen und gut organisierten Behandlungsverlauf. Sie ist der Ansprechpartner für die Betreuung und Unterstützung der Patienten während aller Phasen der Behandlung.",
  "team.griselda.certifications": ["Klinikmanagement", "Patientenkoordination", "Gesundheitsverwaltung"],
  "home.seo_service_areas_label": "Servicegebiete & Behandlungen",
  "home.instagram_error": "Instagram-Posts konnten nicht geladen werden.",
  "home.instagram_retry": "Erneut versuchen",
  "home.instagram_empty_title": "Noch keine Posts vorhanden.",
  "home.instagram_empty_subtitle": "Folge uns auf Instagram für exklusive Einblicke.",
  "home.booking_reception_alt": "Esteva Clinic Empfang",
  "home.newsletter_exists": "Diese E-Mail ist bereits angemeldet.",
  "home.newsletter_error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  "home.developed_by": "Entwickelt von",
  "svc.pricing_hero_tag": "Preisliste",
  "svc.savings_tag": "Preisvergleich",
  "svc.savings_title": "So viel sparen Sie im Vergleich",
  "svc.savings_subtitle": "Gleiche Qualität, modernste Technik — zu einem Bruchteil der Kosten in Deutschland, Österreich oder der Schweiz.",
  "svc.savings_col_treatment": "Behandlung",
  "svc.savings_col_savings": "Ersparnis",
  "svc.packages_tag": "Behandlungspakete",
  "svc.faq_heading": "Häufig gestellte Fragen",
  "svc.pricing_cta_subtitle": "Noch unsicher, welche Behandlung zu Ihnen passt? Im persönlichen Beratungsgespräch finden wir gemeinsam die ideale Lösung.",
  "svc.pricing_faq1_q": "Was ist in den Preispaketen enthalten?",
  "svc.pricing_faq1_a": "Jedes Paket umfasst die genannten Behandlungen sowie die angegebene Nachsorge. In einem persönlichen Beratungsgespräch klären wir alle Details und passen das Paket exakt an Ihre individuellen Bedürfnisse an.",
  "svc.pricing_faq2_q": "Gibt es versteckte Kosten?",
  "svc.pricing_faq2_a": "Nein. Bei Esteva Clinic steht Transparenz an erster Stelle. Der im Beratungsgespräch vereinbarte Preis ist verbindlich. Es gibt keine versteckten Zusatzkosten.",
  "svc.pricing_faq3_q": "Kann ich Behandlungen kombinieren?",
  "svc.pricing_faq3_a": "Selbstverständlich. Viele unserer Kunden wünschen eine Kombination aus verschiedenen Behandlungen. Individuelle Kombinationen besprechen wir gerne im Beratungsgespräch.",
  "svc.pricing_faq4_q": "Welche Zahlungsmethoden akzeptieren Sie?",
  "svc.pricing_faq4_a": "Wir akzeptieren Kreditkarten (Visa, Mastercard, American Express), Banküberweisung sowie Ratenzahlung über unseren Partner. Details dazu erhalten Sie im persönlichen Gespräch.",
  "svc.pricing_faq5_q": "Wie lange dauert die Nachsorge?",
  "svc.pricing_faq5_a": "Die Nachsorge variiert je nach Behandlung. Alle Nachsorgetermine finden in unserer Klinik in Tirana statt. Ein detaillierter Plan wird bei Ihrer Konsultation erstellt.",
  "svc.price_from": "ab ",
  "svc.price_fixed": "Festpreis",
  "svc.view_details_link": "Details ansehen",
  "svc.dental_subtitle": "Transparente Festpreise für alle zahnmedizinischen Behandlungen — inklusive modernster Technik und erfahrener Spezialisten.",
  "svc.dental_cat_implants_label": "Implantate",
  "svc.dental_cat_crowns_label": "Kronen & Brücken",
  "svc.dental_cat_aesthetics_label": "Ästhetik & Zahnspangen",
  "svc.dental_cat_bone_label": "Knochenaufbau",
  "svc.dental_cat_prosthetics_label": "Prothetik",
  "svc.dental_cat_implants_desc": "Moderne Implantate aus hochwertigen Materialien für einen lebenslangen festen Biss.",
  "svc.dental_cat_crowns_desc": "Hochästhetische Kronen aus Zirkon oder Keramik — perfekt auf Ihre Zahnfarbe abgestimmt.",
  "svc.dental_cat_aesthetics_desc": "Ihr schönstes Lächeln: Von professioneller Reinigung bis zur unsichtbaren Zahnspange.",
  "svc.dental_cat_bone_desc": "Notwendige Vorbehandlungen für eine sichere Implantat-Verankerung im Kiefer.",
  "svc.dental_cat_prosthetics_desc": "Flexible und komfortable prothetische Versorgung für mehr Lebensqualität.",
  "svc.surgery_subtitle": "Plastische und ästhetische Chirurgie auf höchstem Niveau — inklusive aller Vor- und Nachsorge in Tirana.",
  "svc.surgery_cat_face_label": "Gesicht & Lifting",
  "svc.surgery_cat_breast_label": "Brustchirurgie",
  "svc.surgery_cat_body_label": "Körperformung",
  "svc.surgery_cat_special_label": "Spezialverfahren",
  "svc.surgery_cat_face_desc": "Feinste ästhetische Chirurgie für ein harmonisches, natürliches Gesichtsprofil.",
  "svc.surgery_cat_breast_desc": "Natürlich schöne Proportionen durch modernste OP-Techniken und Mentor-Implantate.",
  "svc.surgery_cat_body_desc": "Definierte Körperkonturen: Von Liposuktion bis zur umfassenden Straffung.",
  "svc.surgery_cat_special_desc": "Innovative Spezialverfahren für Ihre individuellen Wünsche.",
  "svc.hair_subtitle": "Modernste FUE-Technik mit Sapphire-Klingen — natürlich dichtes Haar, narbenfrei und lebenslang.",
  "svc.hair_bestseller": "Bestseller",
  "svc.hair_treatment_label": "Behandlung",
  "svc.hair_total_price": "Gesamtpreis",
  "svc.hair_all_inclusive": "All-inclusive Paket",
  "svc.hair_graft_overview": "Graft-Pakete im Überblick",
  "svc.hair_popular": "Beliebt",
  "svc.hair_ideal_for": "Ideal für:",
  "svc.hair_included_title": "Im All-inclusive-Paket enthalten",
  "svc.hair_none_available": "Keine Haartransplantations-Behandlungen verfügbar.",
  "svc.hair_tech_method_label": "Methode",
  "svc.hair_tech_method_value": "FUE (Follicular Unit Extraction) — narbenfrei",
  "svc.hair_tech_grafts_label": "Grafts",
  "svc.hair_tech_grafts_value": "Bis zu 5.000 Grafts in einer Sitzung",
  "svc.hair_tech_duration_label": "Dauer",
  "svc.hair_tech_duration_value": "6–8 Stunden (ein Termin)",
  "svc.hair_tech_anesthesia_label": "Anästhesie",
  "svc.hair_tech_anesthesia_value": "Lokalanästhesie mit Sedierung",
  "svc.hair_tech_guarantee_label": "Garantie",
  "svc.hair_tech_guarantee_value": "Lebenslang dichtes Ergebnis",
  "svc.hair_tech_return_label": "Rückreise",
  "svc.hair_tech_return_value": "Ab Tag 3 nach der OP möglich",
  "svc.hair_incl_1": "Persönliches Beratungsgespräch &amp; Haaranalyse",
  "svc.hair_incl_2": "Blutuntersuchung &amp; Gesundheitscheck",
  "svc.hair_incl_3": "FUE-Behandlung mit Sapphire-Klingen",
  "svc.hair_incl_4": "PRP (Plättchenreiches Plasma) zur Heilungsförderung",
  "svc.hair_incl_5": "Spezielles Nachsorge-Shampoo-Set",
  "svc.hair_incl_6": "Alle Nachkontrollen in Tirana",
  "svc.hair_graft1_count": "Bis 2.000",
  "svc.hair_graft1_desc": "Kleinere Lücken &amp; Geheimratsecken",
  "svc.hair_graft1_ideal": "Leichter Haarausfall",
  "svc.hair_graft2_desc": "Vorderer Bereich &amp; Tonsur",
  "svc.hair_graft2_ideal": "Moderater Haarausfall",
  "svc.hair_graft3_desc": "Komplette Wiederherstellung",
  "svc.hair_graft3_ideal": "Fortgeschrittener Haarausfall",
  "svc.detail_not_found": "Behandlung nicht gefunden",
  "svc.detail_back_home": "Zurück zur Startseite",
  "info.map_title": "Esteva Clinic Standort Karte",
  "info.hero_image_alt": "Esteva Clinic Terminbuchung",
  "legal.location_title": "Standort",
  "legal.notfound_seo_title": "Seite nicht gefunden – Esteva Clinic",
  "legal.notfound_seo_description": "Die angeforderte Seite wurde nicht gefunden. Zurück zur Esteva Clinic Startseite.",
  "legal.notfound_title": "Diese Seite wurde nicht gefunden",
  "legal.notfound_subtitle": "Die von Ihnen aufgerufene Seite existiert leider nicht.",
  "adm1.service_surgery": "Chirurgie",
  "adm1.saved": "Gespeichert!",
  "adm1.save_error": "Fehler beim Speichern",
  "adm1.save_error_dot": "Fehler beim Speichern.",
  "adm1.save": "Speichern",
  "adm1.cancel": "Abbrechen",
  "adm1.delete": "Löschen",
  "adm1.refresh": "Aktualisieren",
  "adm1.retry": "Erneut versuchen",
  "adm1.filter_all": "Alle",
  "adm1.filter_visible": "Sichtbar",
  "adm1.filter_hidden": "Ausgeblendet",
  "adm1.action_edit": "Bearbeiten",
  "adm1.action_delete": "Löschen",
  "adm1.action_hide": "Ausblenden",
  "adm1.action_show": "Einblenden",
  "adm1.delete_irreversible": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "adm1.label_name": "Name",
  "adm1.label_email": "E-Mail",
  "adm1.label_phone": "Telefon",
  "adm1.label_package": "Paket",
  "adm1.label_treatment": "Behandlung",
  "adm1.label_status": "Status:",
  "adm1.label_location": "Ort",
  "adm1.label_date": "Datum",
  "adm1.label_rating": "Bewertung",
  "adm1.label_text": "Text",
  "adm1.label_visible": "Sichtbar",
  "adm1.label_verified": "Verifiziert",
  "adm1.bookings_title": "Buchungen & Termine",
  "adm1.bookings_summary": "{{total}} Buchungen · {{new}} neu · {{confirmed}} bestätigt · {{done}} erledigt",
  "adm1.bookings_load_error": "Fehler beim Laden der Buchungen.",
  "adm1.bookings_status_error": "Status konnte nicht aktualisiert werden.",
  "adm1.bookings_saved_notified": "Gespeichert! Kunde wird benachrichtigt.",
  "adm1.bookings_loading": "Buchungen werden geladen...",
  "adm1.bookings_empty_title": "Keine Buchungen gefunden.",
  "adm1.bookings_empty_desc": "Neue Buchungen erscheinen hier, sobald Patienten über das Website-Formular einen Termin anfragen.",
  "adm1.reviews_title": "Bewertungen",
  "adm1.reviews_summary": "{{total}} Bewertungen · {{visible}} sichtbar",
  "adm1.reviews_new": "Neue Bewertung",
  "adm1.reviews_edit": "Bewertung bearbeiten",
  "adm1.reviews_empty_title": "Noch keine Bewertungen vorhanden.",
  "adm1.reviews_empty_desc": "Klicken Sie auf \"Neue Bewertung\", um die erste Kundenstimme hinzuzufügen.",
  "adm1.reviews_delete_confirm": "Bewertung löschen?",
  "adm1.team_title": "Team",
  "adm1.team_count": "{{count}} Teammitglieder",
  "adm1.team_new": "Neues Mitglied",
  "adm1.team_edit": "Mitglied bearbeiten",
  "adm1.team_delete_confirm": "Mitglied löschen?",
  "adm1.label_title_role": "Titel / Rolle",
  "adm1.ph_title_role": "z.B. CEO, Zahnärztin",
  "adm1.label_specialty": "Fachbereich",
  "adm1.ph_specialty": "z.B. Zahnimplantate",
  "adm1.label_bio": "Bio",
  "adm1.label_certifications": "Zertifizierungen (kommasepariert)",
  "adm1.ph_certifications": "z.B. Facharzt Zahnmedizin, Implantologie",
  "adm1.label_languages": "Sprachen (kommasepariert, z.B. DE, EN, IT)",
  "adm1.label_photo": "Foto",
  "adm1.label_order": "Reihenfolge (Nummer)",
  "adm1.treatments_title": "Behandlungen & Preise",
  "adm1.treatments_summary": "{{count}} Behandlungen · Preise in €",
  "adm1.treatments_import": "Standardbehandlungen importieren",
  "adm1.treatments_new": "Neue Behandlung",
  "adm1.treatments_edit": "Behandlung bearbeiten",
  "adm1.treatments_empty": "Keine Behandlungen in dieser Kategorie.",
  "adm1.treatments_delete_confirm": "Behandlung löschen?",
  "adm1.importing": "Importiere…",
  "adm1.import_error": "Fehler beim Import",
  "adm1.col_treatment": "Behandlung",
  "adm1.col_category": "Kategorie",
  "adm1.col_price_al": "Preis AL",
  "adm1.col_price_de": "Preis DE",
  "adm1.col_price_at": "Preis AT",
  "adm1.col_price_ch": "Preis CH",
  "adm1.col_savings": "Ersparnis",
  "adm1.ph_treatment_name": "Behandlungsname",
  "adm1.label_description": "Beschreibung",
  "adm1.ph_description": "Beschreibung...",
  "adm1.label_price_al": "Preis Albanien (€)",
  "adm1.label_price_de": "Preis DE (€)",
  "adm1.label_price_at": "Preis AT (€)",
  "adm1.label_price_ch": "Preis CH (€)",
  "adm1.ph_price_range": "z.B. 1.500 – 2.000",
  "adm1.label_savings_percent": "Ersparnis (%)",
  "adm1.settings_title": "Einstellungen",
  "adm1.settings_subtitle": "Globale Website-Einstellungen verwalten.",
  "adm1.settings_general": "Allgemein",
  "adm1.settings_colors": "Farben",
  "adm1.settings_change_password": "Passwort ändern",
  "adm1.settings_saved_live": "Gespeichert! Änderungen sofort live.",
  "adm1.label_website_name": "Website-Name",
  "adm1.label_logo_url": "Logo-URL",
  "adm1.label_favicon_url": "Favicon-URL",
  "adm1.label_primary_color": "Primärfarbe",
  "adm1.label_accent_color": "Akzentfarbe",
  "adm1.label_secondary_color": "Sekundärfarbe",
  "adm1.ph_new_password": "Neues Passwort...",
  "adm1.pw_too_short": "Passwort muss mindestens 6 Zeichen lang sein.",
  "adm1.pw_changed": "Passwort erfolgreich geändert!",
  "adm1.footer_title": "Footer & Kontakt",
  "adm1.footer_subtitle": "Kontaktdaten und Footer-Einstellungen der Website — exakt wie auf der Seite dargestellt.",
  "adm1.footer_contact_data": "Kontaktdaten",
  "adm1.footer_contact_data_desc": "Telefon, E-Mail, Adresse, Öffnungszeiten — wie im Footer und auf der Kontaktseite",
  "adm1.footer_social_desc": "Instagram & TikTok — exakt wie im Footer und auf der Kontaktseite verlinkt",
  "adm1.footer_tiktok_note": "Auf der Website ist aktuell nur ein Platzhalter (#) verlinkt.",
  "adm1.footer_whatsapp_floating": "WhatsApp (Floating Button)",
  "adm1.label_whatsapp_number": "Nummer (ohne +, z.B. 41765593993)",
  "adm1.label_whatsapp_message": "Vordefinierte Nachricht",
  "adm1.footer_texts": "Footer-Texte",
  "adm1.footer_texts_desc": "Tagline und Copyright — wie im Footer der Website",
  "adm1.label_tagline": "Tagline (unter dem Logo)",
  "adm1.label_copyright": "Copyright-Zeile",
  "adm1.label_address": "Adresse",
  "adm1.label_city_zip": "Stadt / PLZ",
  "adm1.label_country": "Land",
  "adm1.label_opening_hours": "Öffnungszeiten",
  "adm1.login_title": "Admin Login",
  "adm1.login_subtitle": "Esteva Clinic Verwaltung",
  "adm1.login_failed": "Anmeldung fehlgeschlagen. E-Mail oder Passwort falsch.",
  "adm1.label_password": "Passwort",
  "adm1.ph_enter_password": "Passwort eingeben",
  "adm1.pw_hide": "Passwort verbergen",
  "adm1.pw_show": "Passwort anzeigen",
  "adm1.login_loading": "Anmelden…",
  "adm1.login_submit": "Anmelden",
  "adm2.saved": "Gespeichert!",
  "adm2.save_error": "Fehler beim Speichern.",
  "adm2.save": "Speichern",
  "adm2.cancel": "Abbrechen",
  "adm2.delete": "Löschen",
  "adm2.edit": "Bearbeiten",
  "adm2.upload": "Hochladen",
  "adm2.reset": "Zurücksetzen",
  "adm2.reset_all": "Alle zurücksetzen",
  "adm2.reset_lang": "{{lang}} zurücksetzen",
  "adm2.save_changes": "Änderungen speichern",
  "adm2.saving": "Speichern...",
  "adm2.saved_short": "Gespeichert",
  "adm2.saved_live": "Gespeichert! Änderungen sind live.",
  "adm2.remove": "Entfernen",
  "adm2.changed": "Geändert",
  "adm2.optional": "optional",
  "adm2.preview": "Vorschau",
  "adm2.uploaded": "Hochgeladen",
  "adm2.uploading": "Lädt hoch…",
  "adm2.uploading_progress": "Wird hochgeladen...",
  "adm2.upload_failed": "Upload fehlgeschlagen.",
  "adm2.upload_failed_retry": "Upload fehlgeschlagen. Bitte erneut versuchen.",
  "adm2.file_too_large": "Datei zu groß (max. 5 MB).",
  "adm2.file_too_large_compress": "Datei zu groß (max. 5 MB). Bitte komprimieren.",
  "adm2.file_too_large_max": "Die Datei ist zu groß. Maximale Größe: 5 MB.",
  "adm2.max_5mb_jpg_png": "Max. 5 MB, JPG oder PNG",
  "adm2.only_jpg_png_webp": "Bitte nur JPG, PNG oder WebP Dateien hochladen.",
  "adm2.only_image_files": "Bitte nur Bilddateien auswählen (JPG, PNG, WebP).",
  "adm2.file_read_error": "Fehler beim Lesen der Datei. Bitte versuche es erneut.",
  "adm2.file_read_error_smaller": "Fehler beim Lesen der Datei. Versuche eine kleinere Datei.",
  "adm2.no_image": "Kein Bild",
  "adm2.no_image_uploaded": "Noch kein Bild hochgeladen",
  "adm2.image_required": "Bild erforderlich",
  "adm2.edit_image": "Bild bearbeiten",
  "adm2.upload_image": "Bild hochladen",
  "adm2.remove_image": "Bild entfernen",
  "adm2.image_url": "Bild-URL",
  "adm2.image_url_optional": "Bild-URL (optional)",
  "adm2.enter_image_url": "Oder Bild-URL direkt eingeben...",
  "adm2.image_upload_hint": "Bild vom Computer hochladen oder URL einfügen. Hochgeladene Bilder werden lokal gespeichert.",
  "adm2.or_url": "oder URL...",
  "adm2.enter_url": "oder URL eingeben...",
  "adm2.location": "Ort",
  "adm2.description": "Beschreibung",
  "adm2.category": "Kategorie",
  "adm2.filter_all": "Alle",
  "adm2.media_title": "Bilder & Medien",
  "adm2.media_uploaded_count": "{{uploaded}} / {{total}} Bilder hochgeladen",
  "adm2.manage_images": "Bilder verwalten",
  "adm2.images": "Bilder",
  "adm2.images_count": "{{uploaded}} / {{total}} Bilder",
  "adm2.customized": "Angepasst",
  "adm2.no_images_category": "Keine Bilder in dieser Rubrik.",
  "adm2.reset_all_images": "Alle Bilder zurücksetzen",
  "adm2.gallery_comparisons": "Galerie Vergleiche",
  "adm2.gallery_before_after": "Galerie (Before/After)",
  "adm2.page_images": "Seiten-Bilder",
  "adm2.to_website": "Zur Website",
  "adm2.gallery_intro": "Verwalte Before/After-Vergleichsbilder für die Galerie-Seite. Jeder Eintrag besteht aus einem Vorher- und einem Nachher-Bild.",
  "adm2.new_comparison": "Neuer Vergleich",
  "adm2.no_gallery_images_category": "Keine Galerie-Bilder in dieser Kategorie.",
  "adm2.before": "Vorher",
  "adm2.after": "Nachher",
  "adm2.before_image": "Vorher-Bild",
  "adm2.after_image": "Nachher-Bild",
  "adm2.no_label": "Ohne Label",
  "adm2.months_count": "{{count}} Monate",
  "adm2.new_before_after": "Neuer Vorher/Nachher-Vergleich",
  "adm2.edit_comparison": "Vergleich bearbeiten",
  "adm2.add_comparison": "Vergleich hinzufügen",
  "adm2.patient_label": "Patienten-Label",
  "adm2.patient_label_ph": "z.B. Patient 29K",
  "adm2.treatment_label": "Behandlungs-Label",
  "adm2.treatment_label_ph": "z.B. Dental-Kosmetik",
  "adm2.result_after_months": "Ergebnis nach (Monaten)",
  "adm2.result_desc_ph": "Kurze Beschreibung des Ergebnisses...",
  "adm2.cat_hero": "Hero & Hintergründe",
  "adm2.cat_services": "Services / Leistungen",
  "adm2.cat_about": "Über uns / Klinik",
  "adm2.cat_pricing": "Preise / Pakete",
  "adm2.cat_gallery": "Galerie (Before/After)",
  "adm2.cat_team": "Team",
  "adm2.cat_instagram": "Instagram / Social",
  "adm2.gcat_dental": "Dental-Kosmetik",
  "adm2.gcat_surgery": "Chirurgie",
  "adm2.gcat_hair": "Haartransplantation",
  "adm2.gcat_aesthetic": "Ästhetik",
  "adm2.img_home_hero_bg": "Startseite — Hero Hintergrund",
  "adm2.img_home_cta_bg": "Startseite — CTA Hintergrund",
  "adm2.img_home_process": "Startseite — Prozess Hintergrund",
  "adm2.img_home_trust": "Startseite — Vertrauen Hintergrund",
  "adm2.img_about_hero": "Über uns — Hero (Tirana)",
  "adm2.img_services_hero": "Leistungen — Hero",
  "adm2.img_pricing_hero": "Preise — Hero",
  "adm2.img_gallery_hero": "Galerie — Hero",
  "adm2.img_booking_hero": "Terminbuchung — Hero",
  "adm2.img_hair": "Haartransplantation — Bild",
  "adm2.img_dental": "Dental-Kosmetik — Bild",
  "adm2.img_botox": "Botox & Filler — Bild",
  "adm2.confirm_delete": "Wirklich löschen?",
  "adm2.no_subscribers": "Keine Abonnenten vorhanden.",
  "adm2.csv_email": "Email",
  "adm2.csv_language": "Sprache",
  "adm2.csv_status": "Status",
  "adm2.csv_date": "Datum",
  "adm2.col_email": "E-Mail",
  "adm2.col_language": "Sprache",
  "adm2.col_status": "Status",
  "adm2.col_date": "Datum",
  "adm2.col_actions": "Aktionen",
  "adm2.pages_content_title": "Seiten & Inhalte",
  "adm2.pages_content_subtitle": "Bearbeiten Sie die Inhalte jeder Seite der Website.",
  "adm2.language_label": "Sprache:",
  "adm2.editable_fields_count": "{{count}} bearbeitbare Felder",
  "adm2.editable_fields_count2": "{{count}} editierbare Felder",
  "adm2.no_fields_configured": "Keine Felder für diese Seite konfiguriert.",
  "adm2.pc_page_home": "Startseite",
  "adm2.pc_page_services": "Leistungen",
  "adm2.pc_page_about": "Über uns",
  "adm2.pc_page_pricing": "Preise",
  "adm2.pc_page_gallery": "Galerie",
  "adm2.pc_page_team": "Team",
  "adm2.pc_page_booking": "Terminbuchung",
  "adm2.pc_page_contact": "Kontakt",
  "adm2.pc_hero_headline": "Hero-Headline",
  "adm2.pc_hero_subline": "Hero-Subline",
  "adm2.pc_hero_button": "Hero-Button",
  "adm2.pc_about_heading": "Über-uns-Überschrift",
  "adm2.pc_about_text": "Über-uns-Text",
  "adm2.pc_services_heading": "Leistungen-Überschrift",
  "adm2.pc_pricing_heading": "Preise-Überschrift",
  "adm2.pc_testimonials_heading": "Bewertungen-Überschrift",
  "adm2.pc_hair_title": "Haartransplantation Titel",
  "adm2.pc_hair_desc": "Haartransplantation Beschreibung",
  "adm2.pc_hair_heading": "Haartransplantation Überschrift",
  "adm2.pc_dental_title": "Dental-Kosmetik Titel",
  "adm2.pc_dental_desc": "Dental-Kosmetik Beschreibung",
  "adm2.pc_dental_heading": "Dental-Kosmetik Überschrift",
  "adm2.pc_botox_title": "Botox & Filler Titel",
  "adm2.pc_botox_desc": "Botox & Filler Beschreibung",
  "adm2.pc_botox_heading": "Botox & Filler Überschrift",
  "adm2.pc_story_title": "Unsere Geschichte Titel",
  "adm2.pc_story_text": "Unsere Geschichte Text",
  "adm2.pc_philosophy_title": "Philosophie Titel",
  "adm2.pc_philosophy_text": "Philosophie Text",
  "adm2.pc_form_heading": "Formular-Überschrift",
  "adm2.pc_ph_home_hero_title": "z.B. Ihre Premium-Klinik in Tirana",
  "adm2.pc_ph_home_hero_sub": "z.B. Hochwertige Behandlungen zu fairen Preisen...",
  "adm2.pc_ph_home_hero_cta": "z.B. Jetzt Termin buchen",
  "adm2.pc_ph_about_title": "z.B. Über Esteva Clinic",
  "adm2.pc_ph_clinic_desc": "Beschreibung der Klinik...",
  "adm2.pc_ph_our_services": "z.B. Unsere Leistungen",
  "adm2.pc_ph_pricing_packages": "z.B. Unsere Preispakete",
  "adm2.pc_ph_testimonials": "z.B. Das sagen unsere Kunden",
  "adm2.pc_ph_services_sub": "z.B. Entdecken Sie unser vollständiges Behandlungsspektrum...",
  "adm2.pc_ph_hair": "z.B. Haartransplantation",
  "adm2.pc_ph_dental": "z.B. Dental-Kosmetik",
  "adm2.pc_ph_botox": "z.B. Botox & Filler",
  "adm2.pc_ph_description": "Beschreibung...",
  "adm2.pc_ph_about_sub": "z.B. Ihre Premium-Klinik im Herzen von Tirana...",
  "adm2.pc_ph_our_story": "z.B. Unsere Geschichte",
  "adm2.pc_ph_clinic_story": "Die Geschichte der Klinik...",
  "adm2.pc_ph_our_philosophy": "z.B. Unsere Philosophie",
  "adm2.pc_ph_our_prices": "z.B. Unsere Preise",
  "adm2.pc_ph_pricing_sub": "z.B. Transparente Preise — bis zu 70% günstiger...",
  "adm2.pc_ph_gallery_title": "z.B. Vorher-Nachher-Galerie",
  "adm2.pc_ph_gallery_sub": "z.B. Echte Ergebnisse unserer Behandlungen...",
  "adm2.pc_ph_our_team": "z.B. Unser Team",
  "adm2.pc_ph_team_sub": "z.B. Lernen Sie unsere Experten kennen...",
  "adm2.pc_ph_book_appt": "z.B. Termin buchen",
  "adm2.pc_ph_booking_sub": "z.B. Vereinbaren Sie jetzt Ihren Beratungstermin...",
  "adm2.pc_ph_your_data": "z.B. Ihre Daten",
  "adm2.pc_ph_contact": "z.B. Kontakt",
  "adm2.pc_ph_contact_sub": "z.B. So erreichen Sie uns...",
  "adm2.edit_page_title": "{{page}} bearbeiten",
  "adm2.manage_team_members": "Team-Mitglieder verwalten",
  "adm2.edit_pricing_treatments": "Preislisten-Behandlungen bearbeiten",
  "adm2.saved_de_synced": "Gespeichert! (DE → automatisch in alle Sprachen übernommen) Die Änderungen sind jetzt live.",
  "adm2.saved_lang_live": "Gespeichert! ({{lang}}) Die Änderungen sind jetzt live.",
  "adm2.changes_reset_for": "Alle Änderungen für {{lang}} zurückgesetzt.",
  "adm2.lang_editor": "Sprach-Editor ({{lang}})",
  "adm2.lang_editor_de_note": "Sie bearbeiten die DE-Version. Änderungen werden automatisch in alle Sprachen (EN, IT, ES, FR) übernommen.",
  "adm2.lang_editor_other_note": "Sie bearbeiten gerade die {{lang}}-Version. Änderungen werden separat für diese Sprache gespeichert.",
  "adm2.texts": "Texte",
  "adm2.key_label": "Schlüssel:",
  "adm2.changed_original": "Geändert — Original:",
  "adm2.no_editable_fields": "Keine editierbaren Felder",
  "adm2.no_configured_fields": "Diese Seite hat noch keine konfigurierten Felder.",
  "adm2.read_only": "Nur lesbar",
  "adm2.translations_info": "Die Übersetzungen werden direkt in den Sprachdateien gepflegt. Diese Seite zeigt die aktuellen Werte zur Ansicht. Für Änderungen wenden Sie sich an Ihren Entwickler.",
  "adm2.pe_cat_dental": "Zahnmedizin",
  "adm2.pe_cat_surgery": "Plastische Chirurgie",
  "adm2.pe_cat_hair": "Haartransplantation",
  "adm2.pe_new_treatment": "Neue Behandlung",
  "adm2.pe_default_stay": "Day Hospital / 2 Tage Hotel (3 Tage)",
  "adm2.pe_category_reset": "Alle {{category}}-Behandlungen für {{lang}} zurückgesetzt.",
  "adm2.pe_confirm_reset_all": "Wirklich ALLE Preislisten in ALLEN Sprachen zurücksetzen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "adm2.pe_all_reset": "Alle Preislisten komplett zurückgesetzt.",
  "adm2.pe_treatments_count": "{{count}} Behandlung(en)",
  "adm2.pe_edit_hint": "Bearbeiten Sie Name, Preis und optional Aufenthaltsdauer.",
  "adm2.pe_saved_lang": "Gespeichert! ({{lang}})",
  "adm2.pe_treatment_name": "Behandlungsname",
  "adm2.pe_price_eur": "Preis (€)",
  "adm2.pe_price_ph": "z.B. 350 – 400",
  "adm2.pe_stay": "Aufenthalt",
  "adm2.pe_stay_ph": "z.B. Day Hospital / 2 Tage Hotel",
  "adm2.pe_no_treatments_lang": "Keine Behandlungen in dieser Sprache",
  "adm2.pe_no_treatments_hint": "Fügen Sie eine neue Behandlung hinzu oder setzen Sie die Standarddaten zurück.",
  "adm2.pe_add_treatment": "Behandlung hinzufügen",
  "adm2.pe_total_treatments": "Gesamt: {{count}} Behandlungen in {{lang}}",
  "adm2.pe_short_dental": "Dental",
  "adm2.pe_short_surgery": "Chirurgie",
  "adm2.pe_short_hair": "Haar",
  "adm2.tm_lang_de": "Deutsch",
  "adm2.tm_lang_it": "Italienisch",
  "adm2.tm_lang_en": "Englisch",
  "adm2.tm_lang_fr": "Französisch",
  "adm2.tm_lang_es": "Spanisch",
  "adm2.tm_lang_nl": "Niederländisch",
  "adm2.tm_lang_pl": "Polnisch",
  "adm2.tm_lang_al": "Albanisch",
  "adm2.tm_members_count": "Team-Mitglieder ({{count}})",
  "adm2.tm_add_member": "Mitglied hinzufügen",
  "adm2.tm_no_members": "Noch keine Team-Mitglieder.",
  "adm2.tm_add_first_member": "Erstes Mitglied hinzufügen",
  "adm2.tm_new_member": "Neues Mitglied",
  "adm2.tm_edit_member": "Mitglied bearbeiten",
  "adm2.tm_profile_image": "Profilbild",
  "adm2.tm_upload_image_max": "Bild hochladen (max. 5 MB)",
  "adm2.tm_image_hint": "Quadratisches Bild empfohlen. Max. 5 MB.",
  "adm2.tm_name": "Name",
  "adm2.tm_name_ph": "z.B. Nertila Basha",
  "adm2.tm_title_position": "Titel / Position",
  "adm2.tm_title_ph": "z.B. CEO, Zahnärztin",
  "adm2.tm_specialty": "Spezialität",
  "adm2.tm_specialty_ph": "z.B. Zahnimplantate & ästhetische Prothetik",
  "adm2.tm_bio": "Biografie",
  "adm2.tm_bio_ph": "Kurze Biografie des Team-Mitglieds...",
  "adm2.tm_languages": "Sprachen",
  "adm2.tm_certifications": "Zertifikate & Qualifikationen",
  "adm2.tm_cert_ph": "Zertifikat {{num}}",
  "adm2.tm_add_cert": "Zertifikat hinzufügen",
  "shared.chat_title": "Esteva Assistent",
  "shared.chat_online": "Online",
  "shared.chat_restart": "Neu starten",
  "shared.close": "Schliessen",
  "shared.book_appointment": "Termin buchen",
  "shared.chat_input_placeholder": "Nachricht schreiben...",
  "shared.send": "Senden",
  "shared.chat_close": "Chat schliessen",
  "shared.chat_open": "Chat öffnen",
  "shared.whatsapp_contact": "WhatsApp Kontakt",
  "shared.whatsapp_tooltip": "Jetzt auf WhatsApp schreiben",
  "shared.select_language": "Sprache auswählen",
  "shared.image": "Bild",
  "shared.image_too_large": "Datei zu groß (max. 10 MB).",
  "shared.image_upload_failed": "Upload fehlgeschlagen. Bitte erneut versuchen.",
  "shared.image_uploading": "Lädt hoch…",
  "shared.image_select": "Bild auswählen",
  "shared.image_url_placeholder": "oder Bild-URL einfügen…",
  "shared.open_menu": "Menü öffnen",
};

export default common;